import { Maybe } from "@graphql-tools/utils";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { LyfeTooltip } from "@lyfegen-platform/react-common";
import { format } from "date-fns";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { FlexControlProps, FlexFieldController } from "../models/flexible/flex-field-controller";
import { CoverageRequestTherapyDecision, FlexContainerType } from "../models/generated/graphql";
import { GeneralFieldController } from "./general-field-controller";

const UpdateIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="m8.714 4.697-2.428 1.36 1.36-2.429L6.286 1.2l2.428 1.36 2.429-1.36-1.36 2.428 1.36 2.429-2.429-1.36zm11.656 9.519 2.428-1.36-1.36 2.428 1.36 2.428-2.428-1.36-2.428 1.36 1.36-2.428-1.36-2.428 2.428 1.36zM22.798 1.2l-1.36 2.428 1.36 2.429-2.428-1.36-2.428 1.36 1.36-2.429-1.36-2.428 2.428 1.36 2.428-1.36zm-8.411 10.47 2.37-2.369-2.06-2.06-2.37 2.37 2.06 2.06zm1-5.332 2.273 2.273c.379.36.379.991 0 1.37L6.325 21.316c-.379.379-1.01.379-1.37 0l-2.272-2.273c-.38-.36-.38-.99 0-1.37L14.018 6.339c.379-.378 1.01-.378 1.37 0z"
			fill="#7EA6B4"
		/>
	</svg>
);

function RenderBeforeTimeframe(props: { controller: FlexFieldController; path: string; prolongedTo: Object }) {
	const prolongToDate = format(new Date(props.prolongedTo.toString()), "yyyy-MM-dd");
	const { t } = useTranslation();
	const tooltipTitle =
		props.controller.parent.context.entityType.containerType === FlexContainerType.Form
			? `${t("cp-end-date-prolonged-to")} ${prolongToDate}`
			: `${t("tt-end-date-prolonged-to")} ${prolongToDate}}`;

	return (
		<LyfeTooltip title={tooltipTitle}>
			<span style={{ position: "relative", top: "36px" }}>
				<UpdateIcon />
			</span>
		</LyfeTooltip>
	);
}
export class TimeframeFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return value;
	}

	override useControlProps(_path: string): Maybe<FlexControlProps> | undefined {
		const [decisionTherapy] = useFieldValue(AttributeIdentifiers.DecisionTherapy);

		return {
			isTimeframe: true,
			disabled: decisionTherapy === CoverageRequestTherapyDecision.Declined,
		};
	}

	renderBefore(path: string) {
		const prolongedTo = this.parent.context.entityData.prolongedTo;

		return prolongedTo ? <RenderBeforeTimeframe controller={this} path={path} prolongedTo={prolongedTo} /> : <></>;
	}

	protected override createFieldValidationRuleByDataType(translation: (key: string) => string): Yup.AnySchema {
		return Yup.array()
			.test("lower-limit-is-required", function (value) {
				return !value || !!value[0] || this.createError({ message: translation("lower-limit-is-required") });
			})
			.nullable();
	}
}
